/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { FC, useRef, useState } from 'react'
import {
  generateAddress,
  configCategoryMap,
  toAbsoluteUrl,
  QUERIES,
} from '../../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import ImageLightBox from '../../../../../../../_metronic/helpers/components/ImageLightBox'
import { ViewTableModal } from './ViewTableModal'
import { MapImageModal } from './MapImageModal'
import { useAuth } from '../../../../../auth'
import { useMutation, useQueryClient } from 'react-query'
import { updateUser } from '../../core/_requests'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { errorToast, successToast } from '../../../../../../../_metronic/helpers/components/Toaster'
import { HelloTesting } from '../../../../../../../_metronic/helpers/returnDataHelper'
import { useLocation } from 'react-router-dom'
import DdpC from '../../../../../../../_metronic/helpers/DdpC'
import DdpC2 from '../../../../../../../_metronic/helpers/Ddp2'
import IdCall from '../../../../../../../_metronic/helpers/IdCall'
import Coc from '../../../../../../../_metronic/helpers/Coc'
import CommitmentFormEdit from '../../../../../../../_metronic/helpers/CommitmentEdit'
import AssignDdp from '../../../../../../../_metronic/helpers/AssignDdp'
import RegistryDocument from '../../../../../../../_metronic/helpers/RegistryDocument'
import { KycDocumentsModal } from './KycDoc'
import IsccuViewImageForm from '../../form-edit-modal/isccuViewImageForm'
// import ProductionReceipt1 from '../../../../../../../_metronic/helpers/AuditorForm' 
import ProductionReceipt1 from '../../../../../../../_metronic/helpers/ProductionReceipt1'
import ImageView from '../../../../../../../_metronic/helpers/ImageView'
import EnvPermit from '../../../../../../../_metronic/helpers/EnvPermit'
import FacPop from '../../../../../../../_metronic/helpers/FacilityPopUp'
import Rewards from '../../../../../../../_metronic/helpers/Reward'
import MtHubs from '../../../../../../../_metronic/helpers/MtHubs'
import ViewHistoryModal from './ViewHistoryModal'

type Props = {
  user: any
  showImage?: boolean
  mapData?: string
  showImageOnly?: boolean
}

const UserInfoCell: FC<Props> = ({
  user,
  showImageOnly = false,
  showImage = false,
  mapData = '',
}) => {



  const lightBoxRef = useRef<any>(null)

  const { pathname } = useLocation()

  const { isPartner } = useAuth()
  const { itemIdForUpdate } = useListView()
  const ReturnData = () => {
    const queryClient = useQueryClient()
    const { query } = useQueryResponse()

    const assignAuditor = useMutation(
      (id) => updateUser([user.productionId], `productions/assignAuditor`),
      {
        // 💡 response of the mutation is passed to onSuccess
        onSuccess: (d: any) => {
          if (d?.[0]?.message) {
            errorToast(d[0].message)
          }
          // successToast('Success')
          // ✅ update detail view directly
          queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
        },
      }
    )
    const [deletePickupPoints, setDeletePickupPoints] = useState(false)
    const [showImageModal, setshowImageModal] = useState({
      show: false,
      clicked: '',
    })
    const [showMapModal, setShowMapModal] = useState({
      show: false,
      clicked: '',
    })
    if (showMapModal.show) {
      return (
        <MapImageModal
          close={() => setShowMapModal({ show: false, clicked: '' })}
          data={user}
          name={showMapModal.clicked}
        />
      )
    }


    if (showImageModal.show && showImageModal.clicked === 'viewddp') {
      return (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            padding: '0'
          }}
        >

          <div style={{
            backgroundColor: 'white',
            width: '100%',
            maxWidth: '500px',
            height: '70vh',
            margin: '0 auto',
            marginTop: '15vh',  // Add this to center vertically
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px'  // Optional: add border radius
          }}>

            {/* Scrollable content area */}
            <div style={{
              flex: '1',
              overflowY: 'auto'
            }}>
              <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '1.5em', fontWeight: 'bold', color: "black" }}>Digital Product Passport</p>
              <DdpC user={user} />
            </div>

            {/* Fixed close button at bottom */}
            <div style={{
              backgroundColor: 'white',
              padding: '15px',
              textAlign: 'center',
              borderTop: '1px solid #eee',
              flexShrink: 0
            }}>
              <button
                onClick={() => setshowImageModal({ show: false, clicked: '' })}
                style={{
                  background: '#dc3545',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '10px 20px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )
    }


    // if (showImageModal.show && showImageModal.clicked === 'productionId1') {
    //   return (
    //     <div
    //       style={{
    //         position: 'fixed',
    //         top: '0',
    //         left: '0',
    //         width: '100%',
    //         height: '100%',
    //         backgroundColor: 'rgba(0,0,0,0.5)',
    //         zIndex: 1000,
    //         padding: '0'
    //       }}
    //     >

    //       <div style={{
    //         backgroundColor: 'white',
    //         width: '100%',
    //         maxWidth: '500px',
    //         height: '70vh',
    //         margin: '0 auto',
    //         marginTop: '15vh',  // Add this to center vertically
    //         display: 'flex',
    //         flexDirection: 'column',
    //         borderRadius: '8px'  // Optional: add border radius
    //       }}>

    //         {/* Scrollable content area */}
    //         <div style={{
    //           flex: '1',
    //           overflowY: 'auto'
    //         }}>
    //           {/* <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '1.5em', fontWeight: 'bold', color: "black" }}>Digital Product Passport</p> */}
    //           {/* <IdCall user={user} /> */}
    //           <ProductionReceipt1 user={user} />
    //         </div>

    //         {/* Fixed close button at bottom */}
    //         <div style={{
    //           backgroundColor: 'white',
    //           padding: '15px',
    //           textAlign: 'center',
    //           borderTop: '1px solid #eee',
    //           flexShrink: 0
    //         }}>
    //           <button
    //             onClick={() => setshowImageModal({ show: false, clicked: '' })}
    //             style={{
    //               background: '#dc3545',
    //               color: 'white',
    //               border: 'none',
    //               borderRadius: '5px',
    //               padding: '10px 20px',
    //               cursor: 'pointer',
    //               fontSize: '14px'
    //             }}
    //           >
    //             Close
    //           </button>
    //         </div>
    //       </div>
    //     </div>
    //   )
    // }



    if (showImageModal.show && showImageModal.clicked === 'CertificateTry') {
      return (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            padding: '0'
          }}
        >
          <div style={{
            backgroundColor: 'white',
            width: '90%',
            maxWidth: '800px',
            height: '85vh',
            margin: '0 auto',
            marginTop: '7.5vh',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px',
            border: '1px solid #e0e0e0',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
          }}>
            <div style={{
              flex: '1',
              overflowY: 'auto'
            }}>
              <ImageView user={user} />
            </div>
            <div style={{
              backgroundColor: 'white',
              padding: '15px',
              textAlign: 'right',
              borderTop: '1px solid #eee',
              flexShrink: 0
            }}>
              <button
                onClick={() => setshowImageModal({ show: false, clicked: '' })}
                style={{
                  background: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '10px 20px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )
    }

    if (showImageModal.show && showImageModal.clicked === 'productionId1') {
      return (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            padding: '0'
          }}
        >
          <div style={{
            backgroundColor: 'white',
            width: '90%',
            maxWidth: '800px',
            height: '85vh',
            margin: '0 auto',
            marginTop: '7.5vh',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px',
            border: '1px solid #e0e0e0',        // Changed to light gray border
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
          }}>
            {/* Scrollable content area */}
            <div style={{
              flex: '1',
              overflowY: 'auto'
            }}>
              {/* <ProductionReceipt1 user={user} /> */}
              <IdCall user={user} />
            </div>
            {/* Fixed close button at bottom right */}
            <div style={{
              backgroundColor: 'white',
              padding: '15px',
              textAlign: 'right',
              borderTop: '1px solid #eee',
              flexShrink: 0
            }}>
              <button
                onClick={() => setshowImageModal({ show: false, clicked: '' })}
                style={{
                  background: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '10px 20px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )
    }


    // if (showImageModal.show && showImageModal.clicked === 'productionId1') {
    //   return (
    //     <div
    //       style={{
    //         position: 'fixed',
    //         top: '0',
    //         left: '0',
    //         width: '100%',
    //         height: '100%',
    //         backgroundColor: 'rgba(0,0,0,0.5)',
    //         zIndex: 1000,
    //         padding: '0'
    //       }}
    //       onClick={(e) => {
    //         // Only close if clicking directly on the backdrop, not on children
    //         if (e.target === e.currentTarget) {
    //           setshowImageModal({ show: false, clicked: '' });
    //         }
    //       }}
    //     >
    //       <div
    //         style={{
    //           backgroundColor: 'white',
    //           width: '90%',
    //           maxWidth: '800px',
    //           height: '85vh',
    //           margin: '0 auto',
    //           marginTop: '7.5vh',
    //           display: 'flex',
    //           flexDirection: 'column',
    //           borderRadius: '8px',
    //           border: '1px solid #e0e0e0',
    //           boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
    //         }}
    //         onClick={(e) => e.stopPropagation()}
    //       >
    //         {/* Scrollable content area */}
    //         <div style={{
    //           flex: '1',
    //           overflowY: 'auto'
    //         }}>
    //           {/* <ProductionReceipt1 user={user} /> */}
    //           <IdCall user={user} />
    //         </div>
    //         {/* Fixed close button at bottom right */}
    //         <div style={{
    //           backgroundColor: 'white',
    //           padding: '15px',
    //           textAlign: 'right',
    //           borderTop: '1px solid #eee',
    //           flexShrink: 0
    //         }}>
    //           <button
    //             onClick={() => setshowImageModal({ show: false, clicked: '' })}
    //             style={{
    //               background: '#6c757d',
    //               color: 'white',
    //               border: 'none',
    //               borderRadius: '5px',
    //               padding: '10px 20px',
    //               cursor: 'pointer',
    //               fontSize: '14px'
    //             }}
    //           >
    //             Close
    //           </button>
    //         </div>
    //       </div>
    //     </div>
    //   )
    // }

    // if (showImageModal.show && showImageModal.clicked === 'FormView') {
    //   return (
    //     <div
    //       style={{
    //         position: 'fixed',
    //         top: '0',
    //         left: '0',
    //         width: '100%',
    //         height: '100%',
    //         backgroundColor: 'rgba(0,0,0,0.5)',
    //         zIndex: 1000,
    //         padding: '0'
    //       }}
    //     >
    //       <div style={{
    //         backgroundColor: 'white',
    //         width: '90%',
    //         maxWidth: '800px',
    //         height: '85vh',
    //         margin: '0 auto',
    //         marginTop: '7.5vh',
    //         display: 'flex',
    //         flexDirection: 'column',
    //         borderRadius: '8px',
    //         border: '1px solid #e0e0e0',        // Changed to light gray border
    //         boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
    //       }}>
    //         {/* Scrollable content area */}
    //         <div style={{
    //           flex: '1',
    //           overflowY: 'auto'
    //         }}>
    //           <ProductionReceipt1 user={user} />
    //         </div>
    //         {/* Fixed close button at bottom right */}
    //         <div style={{
    //           backgroundColor: 'white',
    //           padding: '15px',
    //           textAlign: 'right',
    //           borderTop: '1px solid #eee',
    //           flexShrink: 0
    //         }}>
    //           <button
    //             onClick={() => setshowImageModal({ show: false, clicked: '' })}
    //             style={{
    //               background: '#6c757d',
    //               color: 'white',
    //               border: 'none',
    //               borderRadius: '5px',
    //               padding: '10px 20px',
    //               cursor: 'pointer',
    //               fontSize: '14px'
    //             }}
    //           >
    //             Close
    //           </button>
    //         </div>
    //       </div>
    //     </div>
    //   )
    // }

    // if (showImageModal.show && showImageModal.clicked === 'cocpopup') {
    //   return (
    //     <div
    //       style={{
    //         position: 'fixed',
    //         top: '0',
    //         left: '0',
    //         width: '100%',
    //         height: '100%',
    //         backgroundColor: 'rgba(0,0,0,0.5)',
    //         zIndex: 1000,
    //         padding: '0'
    //       }}
    //     >
    //       <div style={{
    //         backgroundColor: 'white',
    //         width: '100%',
    //         maxWidth: '500px',
    //         height: '70vh',
    //         margin: '0 auto',
    //         marginTop: '15vh',  // Add this to center vertically
    //         display: 'flex',
    //         flexDirection: 'column',
    //         borderRadius: '8px'  // Optional: add border radius
    //       }}>

    //         {/* Scrollable content area */}
    //         <div style={{
    //           flex: '1',
    //           overflowY: 'auto'
    //         }}>
    //           <Coc user={user} />
    //         </div>

    //         {/* Fixed close button at bottom */}
    //         <div style={{
    //           backgroundColor: 'white',
    //           padding: '15px',
    //           textAlign: 'center',
    //           borderTop: '1px solid #eee',
    //           flexShrink: 0
    //         }}>
    //           <button
    //             onClick={() => setshowImageModal({ show: false, clicked: '' })}
    //             style={{
    //               background: '#dc3545',
    //               color: 'white',
    //               border: 'none',
    //               borderRadius: '5px',
    //               padding: '10px 20px',
    //               cursor: 'pointer',
    //               fontSize: '14px'
    //             }}
    //           >
    //             Close
    //           </button>
    //         </div>
    //       </div>
    //     </div>
    //   )
    // }


    if (showImageModal.show && showImageModal.clicked === 'cocpopup') {
      return (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            padding: '0'
          }}
        >
          <div style={{
            backgroundColor: 'white',
            width: '90%',
            maxWidth: '800px',
            height: '85vh',
            margin: '0 auto',
            marginTop: '7.5vh',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px',
            border: '1px solid #e0e0e0',        // Changed to light gray border
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
          }}>
            {/* Scrollable content area */}
            <div style={{
              flex: '1',
              overflowY: 'auto'
            }}>
              {/* <ProductionReceipt1 user={user} /> */}
              {/* <IdCall user={user} /> */}
              <Coc user={user} />
            </div>
            {/* Fixed close button at bottom right */}
            <div style={{
              backgroundColor: 'white',
              padding: '15px',
              textAlign: 'right',
              borderTop: '1px solid #eee',
              flexShrink: 0
            }}>
              <button
                onClick={() => setshowImageModal({ show: false, clicked: '' })}
                style={{
                  background: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '10px 20px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )
    }



    if (showImageModal.show && showImageModal.clicked === 'couponRewards') {
      return (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div style={{
            backgroundColor: 'white',
            width: '90%',
            maxWidth: '600px',
            maxHeight: '80vh',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px',
            border: '1px solid #e0e0e0',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
          }}>
            {/* Scrollable content area */}
            <div style={{
              flex: '1',
              overflowY: 'auto',
              padding: '20px'
            }}>
              <Rewards user={user} />
            </div>
            {/* Fixed close button at bottom right */}
            <div style={{
              backgroundColor: 'white',
              padding: '15px',
              textAlign: 'right',
              borderTop: '1px solid #eee',
              flexShrink: 0
            }}>
              <button
                onClick={() => setshowImageModal({ show: false, clicked: '' })}
                style={{
                  background: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '10px 20px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )
    }
    if (showImageModal.show && showImageModal.clicked === 'MThubs') {
      return (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div style={{
            backgroundColor: 'white',
            width: '90%',
            maxWidth: '600px',
            maxHeight: '80vh',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px',
            border: '1px solid #e0e0e0',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
          }}>
            {/* Scrollable content area */}
            <div style={{
              flex: '1',
              overflowY: 'auto',
              padding: '20px'
            }}>
              <MtHubs user={user} deletePickupPoints={deletePickupPoints} setDeletePickupPoints={setDeletePickupPoints} />
            </div>
            {/* Fixed close button at bottom right */}
            <div style={{
              backgroundColor: 'white',
              padding: '15px',
              textAlign: 'right',
              borderTop: '1px solid #eee',
              flexShrink: 0,
              display: "flex",
              justifyContent: "space-between"
            }}>
              <button
                onClick={() => setDeletePickupPoints(true)}
                style={{
                  background: '#f8285a',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '10px 20px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Delete
              </button>
              <button
                onClick={() => setshowImageModal({ show: false, clicked: '' })}
                style={{
                  background: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '10px 20px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )
    }

    if (showImageModal.show && showImageModal.clicked === 'commitmentEdit') {
      return (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px'
          }}
        >
          <div style={{
            backgroundColor: 'white',
            width: '90%',
            maxWidth: '800px',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px',
            border: '1px solid #e0e0e0',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            maxHeight: '95vh',
          }}>
            {/* Scrollable content area */}
            <div style={{
              flex: '1',
              overflowY: 'visible',
              overflowX: 'hidden',
              overflow: 'visible'
            }}>
              <CommitmentFormEdit user={user} />
            </div>
            {/* Fixed buttons at bottom */}
            <div style={{
              backgroundColor: 'white',
              padding: '15px',
              textAlign: 'right',
              borderTop: '1px solid #eee',
              flexShrink: 0,
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '10px'
            }}>
              <button
                type="submit"
                form="commitment-form"
                style={{
                  background: 'black',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '10px 20px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                {/* {user?.id ? 'Update' : 'Submit'} */}
                Submit
              </button>
              <button
                onClick={() => setshowImageModal({ show: false, clicked: '' })}
                style={{
                  background: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '10px 20px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )
    }


    if (showImageModal.show && showImageModal.clicked === 'FormView') {
      return (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            padding: '0'
          }}
        >
          <div style={{
            backgroundColor: 'white',
            width: '90%',
            maxWidth: '800px',
            height: '85vh',
            margin: '0 auto',
            marginTop: '7.5vh',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px',
            border: '1px solid #e0e0e0',        // Changed to light gray border
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
          }}>
            {/* Scrollable content area */}
            <div style={{
              flex: '1',
              overflowY: 'auto'
            }}>
              {/* <ProductionReceipt1 user={user} /> */}
              {/* <IdCall user={user} /> */}
              <ProductionReceipt1 user={user} />

            </div>
            {/* Fixed close button at bottom right */}
            <div style={{
              backgroundColor: 'white',
              padding: '15px',
              textAlign: 'right',
              borderTop: '1px solid #eee',
              flexShrink: 0
            }}>
              <button
                onClick={() => setshowImageModal({ show: false, clicked: '' })}
                style={{
                  background: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '10px 20px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )
    }






    // if (showImageModal.show && showImageModal.clicked === 'productionId1') {
    //   return (
    //     <div
    //       style={{
    //         position: 'fixed',
    //         top: '0',
    //         left: '0',
    //         width: '100%',
    //         height: '100%',
    //         backgroundColor: 'rgba(0,0,0,0.5)',
    //         zIndex: 1000,
    //         padding: '0'
    //       }}
    //     >
    //       <div style={{
    //         backgroundColor: 'white',
    //         width: '100%',
    //         maxWidth: '500px',
    //         height: '70vh',
    //         margin: '0 auto',
    //         marginTop: '15vh',  // Add this to center vertically
    //         display: 'flex',
    //         flexDirection: 'column',
    //         borderRadius: '8px'  // Optional: add border radius
    //       }}>

    //         {/* Scrollable content area */}
    //         <div style={{
    //           flex: '1',
    //           overflowY: 'auto'
    //         }}>
    //           <Coc user={user} />
    //         </div>

    //         {/* Fixed close button at bottom */}
    //         <div style={{
    //           backgroundColor: 'white',
    //           padding: '15px',
    //           textAlign: 'center',
    //           borderTop: '1px solid #eee',
    //           flexShrink: 0
    //         }}>
    //           <button
    //             onClick={() => setshowImageModal({ show: false, clicked: '' })}
    //             style={{
    //               background: '#dc3545',
    //               color: 'white',
    //               border: 'none',
    //               borderRadius: '5px',
    //               padding: '10px 20px',
    //               cursor: 'pointer',
    //               fontSize: '14px'
    //             }}
    //           >
    //             Close
    //           </button>
    //         </div>
    //       </div>
    //     </div>
    //   )
    // }





    if (showImageModal.show && showImageModal.clicked === 'viewPdf') {
      return (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            padding: '0',
            display: 'flex',
            alignItems: 'center'  // Centers the modal vertically
          }}
        >
          <div style={{
            backgroundColor: 'white',
            width: '70%',
            maxWidth: '700px',
            height: 'calc(100vh - 60px)',  // Full height minus top/bottom margins
            margin: '30px auto',           // 30px top/bottom margin, centered horizontally
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '12px',          // Added border radius
            overflow: 'hidden',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)'  // Optional: nice shadow effect
          }}>
            <div style={{
              flex: '1',
              overflow: 'hidden',
              height: '100%'
            }}>
              <IsccuViewImageForm user={user} />
            </div>
            {/* Fixed close button at bottom right */}
            <div style={{
              backgroundColor: 'white',
              padding: '15px',
              textAlign: 'right',
              borderTop: '1px solid #eee',
              flexShrink: 0
            }}>
              <button
                onClick={() => setshowImageModal({ show: false, clicked: '' })}
                style={{
                  background: '#333333',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '10px 20px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )
    }


    if (showImageModal.show && showImageModal.clicked === 'assignDDP') {
      return (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div style={{
            backgroundColor: 'white',
            width: '90%',
            maxWidth: '500px',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            position: 'relative'
          }}>
            {/* Close button in top right */}
            <button
              onClick={() => setshowImageModal({ show: false, clicked: '' })}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: '#999'
              }}
            >
              ×
            </button>
            <AssignDdp user={user} onClose={() => setshowImageModal({ show: false, clicked: '' })} />

            {/* Close button at bottom */}
            <div style={{
              marginTop: '20px',
              textAlign: 'center'
            }}>
            </div>
          </div>
        </div>
      )
    }


    // if (showImageModal.show && showImageModal.clicked === 'assignDDP2') {
    //   return (
    //     <div
    //       style={{
    //         position: 'fixed',
    //         top: '0',
    //         left: '0',
    //         width: '100%',
    //         height: '100%',
    //         backgroundColor: 'rgba(0,0,0,0.5)',
    //         zIndex: 1000,
    //         display: 'flex',
    //         alignItems: 'center',
    //         justifyContent: 'center'
    //       }}
    //     >
    //       <div style={{
    //         backgroundColor: 'white',
    //         width: '90%',
    //         maxWidth: '500px',
    //         borderRadius: '8px',
    //         padding: '20px',
    //         boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    //         position: 'relative'
    //       }}>
    //         {/* Close button in top right */}
    //         <button
    //           onClick={() => setshowImageModal({ show: false, clicked: '' })}
    //           style={{
    //             position: 'absolute',
    //             top: '10px',
    //             right: '10px',
    //             background: 'none',
    //             border: 'none',
    //             fontSize: '20px',
    //             cursor: 'pointer',
    //             color: '#999'
    //           }}
    //         >
    //           ×
    //         </button>
    //         {/* <AssignDdp user={user} onClose={() => setshowImageModal({ show: false, clicked: '' })} /> */}
    //         <DdpC2 user={user} />
    //         {/* Close button at bottom */}
    //         <div style={{
    //           marginTop: '20px',
    //           textAlign: 'center'
    //         }}>
    //         </div>
    //       </div>
    //     </div>
    //   )
    // }


    if (showImageModal.show && showImageModal.clicked === 'assignDDP2') {
      return (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            padding: '0'
          }}
        >

          <div style={{
            backgroundColor: 'white',
            width: '100%',
            maxWidth: '500px',
            height: '70vh',
            margin: '0 auto',
            marginTop: '15vh',  // Add this to center vertically
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px'  // Optional: add border radius
          }}>

            {/* Scrollable content area */}
            <div style={{
              flex: '1',
              overflowY: 'auto'
            }}>
              <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '1.5em', fontWeight: 'bold', color: "black" }}>Digital Product Passport</p>
              <DdpC2 user={user} />
            </div>

            {/* Fixed close button at bottom */}
            <div style={{
              backgroundColor: 'white',
              padding: '15px',
              textAlign: 'center',
              borderTop: '1px solid #eee',
              flexShrink: 0
            }}>
              <button
                onClick={() => setshowImageModal({ show: false, clicked: '' })}
                style={{
                  background: '#dc3545',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '10px 20px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )
    }

    if (showImageModal.show && showImageModal.clicked === 'KYC') {
      return (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div style={{
            backgroundColor: 'white',
            width: '90%',
            maxWidth: '500px',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            position: 'relative'
          }}>
            {/* Close button in top right */}
            <button
              onClick={() => setshowImageModal({ show: false, clicked: '' })}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: '#999'
              }}
            >
              ×
            </button>
            <KycDocumentsModal
              user={user}
              show={true}
              onClose={() => setshowImageModal({ show: false, clicked: '' })}
            />
            {/* Close button at bottom */}
            <div style={{
              marginTop: '20px',
              textAlign: 'center'
            }}>
            </div>
          </div>
        </div>
      )
    }

    if (showImageModal.show && showImageModal.clicked === 'Registrypopup') {
      return (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div style={{
            backgroundColor: 'white',
            width: '90%',
            maxWidth: '500px',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            position: 'relative'
          }}>
            {/* Close button in top right */}
            <button
              onClick={() => setshowImageModal({ show: false, clicked: '' })}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: '#999'
              }}
            >
              ×
            </button>

            {/* Pass a prop to disable the inner modal */}
            <RegistryDocument
              user={user}
              onClose={() => setshowImageModal({ show: false, clicked: '' })}
              disableModal={true}  // Add this prop
            />
          </div>
        </div>
      )
    }



    if (showImageModal.show && showImageModal.clicked === 'viewHistory') {
      return (
        <ViewHistoryModal
          close={() => setshowImageModal({ show: false, clicked: '' })}
          data={user}
          name={showImageModal.clicked}
        />
      )
    }

    if (showImageModal.show) {
      return (
        <ViewTableModal
          close={() => setshowImageModal({ show: false, clicked: '' })}
          data={user}
          name={showImageModal.clicked}
        />
      )
    }



    // if (mapData.includes('[')) return clipText(accessNestedProperty(user, mapData), 30)
    return HelloTesting({
      user,
      mapData,
      pathname,
      isPartner,
      lightBoxRef,
      assignAuditor,
      setShowMapModal,
      setshowImageModal,
    })
  }
  return (
    <div className='align-items-center'>
      {showImageOnly && (
        <div className='symbol symbol-circle swymbol-50px overflow-hidden me-3'>
          <div className='symbol-label'>
            <img
              src={user.icon || user.logo || toAbsoluteUrl(`/media/${user.avatar}`)}
              alt={user.name}
              className='w-100'
              onClick={() =>
                lightBoxRef?.current?.open(
                  user.icon || user.logo || toAbsoluteUrl(`/media/${user.avatar}`),
                  itemIdForUpdate
                )
              }
            />
          </div>
          {user.id && mapData && <ImageLightBox ref={lightBoxRef} />}
        </div>
      )}
      {showImage && (
        <div className='symbol symbol-circle swymbol-50px overflow-hidden me-3'>
          <a href='#'>
            {user.avatar ? (
              <div className='symbol-label'>
                <img
                  src={user.icon || toAbsoluteUrl(`/media/${user.avatar}`)}
                  alt={user.name}
                  className='w-100'
                />
              </div>
            ) : (
              <div
                className={clsx(
                  'symbol-label fs-3',
                  `bg-light-${user.initials?.state}`,
                  `text-${user.initials?.state}`
                )}
              >
                {user.initials?.label}
              </div>
            )}
          </a>
        </div>
      )}
      {!showImageOnly && (
        <div className='d-flex flex-column'>
          <a href='#' className='text-gray-800 text-hover-primary mb-1'>
            {ReturnData()}
          </a>
        </div>
      )}
    </div>
  )
}

function clipText(text, maxLength = 25, clipper = '...') {
  if (!text) return text
  return text.length > maxLength ? text.slice(0, maxLength - clipper.length) + clipper : text || '-'
}

export { UserInfoCell }





